import axios from "./httpService";

export const getFaqApi = () => axios.get("/v3/support/faq");
